import { MutationTree } from 'vuex'
import { blankModels, loadingModels } from '../editor-model/constants'
import State from './types'
import { ResponseArray } from '../types'
import { Model } from '../editor/types'

export const mutations: MutationTree<State> = {
  setPreloaded(state, { value }) {
    state.preloaded = value
  },
  modelSearchResultsLoading(state: State) {
    state.error = false
    state.modelSearchResults = loadingModels
  },
  modelSearchResultsBlank(state: State) {
    state.error = false
    state.modelSearchResults = blankModels
  },
  modelSearchResultsLoaded(
    state: State,
    { modelSearchResults }: { modelSearchResults: ResponseArray<Model> },
  ) {
    state.error = false
    state.modelSearchResults = modelSearchResults
  },
  modelSearchResultsError(state) {
    state.error = true
    state.modelSearchResults = loadingModels
  },
  addRecentlySearchedPcn(state, pcnCatalogNumber: string) {
    const index = state.recentlySearchedPcns.findIndex(
      (i) => i === pcnCatalogNumber,
    )
    if (index > -1) {
      state.recentlySearchedPcns.splice(index, 1)
    }

    state.recentlySearchedPcns.unshift(pcnCatalogNumber)

    if (state.recentlySearchedPcns.length > 10) {
      state.recentlySearchedPcns.splice(
        state.recentlySearchedPcns.length - 1,
        1,
      )
    }
  },
  productModelsToggled(state, isOpen) {
    state.isShowingProductModels = isOpen
  },
  categoriesOpenReset(state) {
    state.categoryOpen = {}
    state.productClassOpen = {}
    state.manufacturingSeriesOpen = {}
    state.productOpen = {}
    const collapsedTree = state.treeCategories.map((category) => {
      return {
        ...category,
        open: false,
        ProductClasses: category.ProductClasses.map((product) => {
          return {
            ...product,
            open: false,
            ManufacturingSeries: product.ManufacturingSeries.map((seri) => {
              return { ...seri, open: false }
            }),
          }
        }),
      }
    })

    state.treeCategories = collapsedTree
    state.isShowingProductModels = false
  },
  updateTerm(state: State, newTerm: string) {
    state.error = false
    state.term = newTerm
  },
}
